import gsap from "gsap/all";

export default () => ({
  init() {
    this.initAnimation();
  },

  initAnimation() {
    const inBackend = document.body.classList.contains("neos-backend");

    if (inBackend) return;

    const downloadItem = document.querySelectorAll(".downloads .download-item");
    const downloadsSections = document.querySelectorAll(".downloads");

    downloadsSections.forEach((downloadItem) => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: downloadItem,
            start: "top 75%",
          },
        })
        .to(downloadItem.querySelectorAll(".download-item"), {
          xPercent: 100,
          stagger: 0.1,
          opacity: 1,
          duration: 0.8,
          onComplete: function () {
            // clear transform to maintain responsiveness of element
            this.targets().forEach((el) => {
              el.classList.remove("slide-in-left");
              el.style.removeProperty("transform");
            });
          },
        });
    });
  },
});
